import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CustomerRow } from './CustomerRow';
import { useCommon } from 'src/AppState/Common';
import { CustomersListState } from 'src/AppState/CustomersListState/CustomersListState';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';

export const CustomersList = observer('CustomersList', () => {
    const common = useCommon();

    const { isReady, isError, errors, isRequestMade, isSearching, customers } = CustomersListState.get(common);

    if (!isRequestMade) {
        return null;
    }

    if (isSearching) {
        return (
            <LoadingV2
                title='Searching for customers...'
                dataTest='customers-list-loading'
            />
        );
    }

    if (isError) {
        return <div>{errors}</div>;
    }

    if (customers.length > 0) {
        return (
            <table className='table__striped table__rows-highlighted'>
                <thead>
                    <tr>
                        <th className='links'>Links</th>
                        <th>Account ID</th>
                        <th>First name</th>
                        <th>Surname</th>
                        <th>DOB</th>
                        <th>Postcode</th>
                        <th>Account status</th>
                        <th>KYC</th>
                    </tr>
                </thead>
                <tbody>
                    {customers.map((customerData) => {
                        return (
                            <CustomerRow
                                key={customerData.id}
                                customerModel={customerData}
                            />
                        );
                    })}
                </tbody>
            </table>
        );
    }

    if (isReady && customers.length === 0) {
        return <div>Not found customers with this criteria.</div>;
    }

    return null;
});
